import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import useUserService from '@hooks/queries/credential/onboarding/useUserService';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_OFF_CRED_FREE, SUC_OFF_CRED_FREE } from '../../utils/strings';
import { IClaim, ICredPayload } from './types';

export const useHandleFree = () => {
  const userService = useUserService();
  const { submit } = useExerciseSubmission(
    UserService.UserService_OfferFreeCredential,
    SUC_OFF_CRED_FREE,
    ERR_OFF_CRED_FREE,
  );
  return async (payload: ICredPayload, claims: IClaim[]) => {
    if (!userService.data) return;

    const p = {
      userServiceCid: userService.data.contractId,
      holder: payload.holder,
      id: payload.id,
      description: payload.description,
      claims,
    };

    await submit({ cid: userService.data.contractId, argument: p });
  };
};
